import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { riskApi } from '../../api/riskApi';
import { Shield, Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';

export const RiskDashboard = () => {
    const { token } = useAuth();
    const navigate = useNavigate();
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const res = await riskApi.getHistory(token);
                setHistory(res.history || []);
            } catch (err) {
                console.error("Error fetching risk history", err);
            } finally {
                setLoading(false);
            }
        };
        fetchHistory();
    }, [token]);

    const handleRowClick = (jobId) => {
        navigate(`/risk/report/${jobId}`);
    };

    return (
        <div className="space-y-6">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                        <Shield className="h-6 w-6 text-indigo-600" />
                        Riesgo Marcario
                    </h1>
                    <p className="text-sm text-gray-500 mt-1">Historial de escaneos de viabilidad y análisis de choques</p>
                </div>
                <Button onClick={() => navigate('/risk/new')} className="bg-indigo-600 hover:bg-indigo-700 text-white flex items-center gap-2">
                    <Plus className="h-4 w-4" />
                    Nuevo Análisis
                </Button>
            </div>

            <div className="bg-white shadow rounded-lg overflow-hidden border border-gray-200">
                {loading ? (
                    <div className="p-8 text-center text-gray-500">Cargando historial...</div>
                ) : history.length === 0 ? (
                    <div className="p-12 text-center text-gray-500 flex flex-col items-center">
                        <Shield className="h-12 w-12 text-gray-300 mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">No hay análisis registrados</h3>
                        <p className="text-sm">Inicia tu primer escaneo automatizado en el Acervo del IMPI.</p>
                        <Button variant="outline" className="mt-6" onClick={() => navigate('/risk/new')}>
                            Comenzar Análisis
                        </Button>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Marca Propuesta</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Clases</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estatus</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {history.map((job) => (
                                    <tr
                                        key={job.id}
                                        className="hover:bg-gray-50 cursor-pointer"
                                        onClick={() => handleRowClick(job.id)}
                                    >
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {new Date(job.created_at).toLocaleDateString()}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {job.proposed_name}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {(job.confirmed_classes || []).join(', ')}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                                                ${job.status === 'COMPLETED' ? 'bg-green-100 text-green-800' :
                                                    job.status === 'RUNNING' ? 'bg-blue-100 text-blue-800' :
                                                        job.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                                                            'bg-red-100 text-red-800'}`}>
                                                {job.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};
